import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { APIS, URLS, SF_VHCL_MKER_MGMT_INFO } from "./services/OsciVhclMkerMgmtService";

/*
 * Vehicle Maker Modification
 * !== 차량 제조사 수정 ==!
 */
export const OSCI0105005S = (props: any) => {
    const {} = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { vhclMkerCd } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0088" }],
    });

    const form = {
        vhclMkerMgmtInfo: useForm({
            defaultSchema: SF_VHCL_MKER_MGMT_INFO,
        }),
    };

    const fetch = {
        //   Check Vehicle Maker Information !== 차량 제조사 정보 조회 ==!
        getVhclMkerInfo: useFetch({
            api: (data) => APIS.getVhclMkerInfo(vhclMkerCd),
            enabled: !!vhclMkerCd,
            onSuccess: (data) => {
                const vhclMkerMgmtInfo = data.vhclMkerMgmtInfo.content;
                form.vhclMkerMgmtInfo.setValues(vhclMkerMgmtInfo);
            },
            onError: (error) => {},
            showToast: true,
        }),
        saveVhclMkerInfo: useFetch({
            api: (data: any) => APIS.saveVhclMkerInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        navigate(URLS.osci0105006q + "/" + form.vhclMkerMgmtInfo.getValue("vhclMkerCd"));
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        // Vehicle Maker Duplicate Check !== 차량 제조사 중복 체크 ==!
        saveVhclMkerInfo: () => {
            if (!comnUtils.isEmpty(form.vhclMkerMgmtInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.vhclMkerMgmtInfo.handleSubmit(
                () => {
                    const data = form.vhclMkerMgmtInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveVhclMkerInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        form.vhclMkerMgmtInfo.setSchema("vhclMkerCd", { edit: false });
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.vhclMkerCd} />
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.vhclMkerNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.loclYn} />
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.useYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button
                        role={"list"}
                        onClick={() => {
                            navigate(`${URLS.osci0105003q}`);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.saveVhclMkerInfo} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
